export const EVENT_TYPE = {
  MEETING: 'MEETING',
  FORUM_ROUNDTABLE: 'FORUM_ROUNDTABLE',
  FIRESIDE_CHAT: 'FIRESIDE_CHAT',
  HACKATHON_JAM: 'HACKATHON_JAM',
  TOPIC_MEETUP: 'TOPIC_MEETUP',
  SYMPOSIUM: 'SYMPOSIUM',
  CONFERENCE: 'CONFERENCE',
  SUMMIT: 'SUMMIT',
  CEREMONY: 'CEREMONY',
  SEMINAR: 'SEMINAR',
  TRAINING: 'TRAINING',
  WORKSHOP: 'WORKSHOP',
  RETREAT_OFFSITE: 'RETREAT_OFFSITE',
  PRODUCT_LAUNCH: 'PRODUCT_LAUNCH',
  EXPERIENCE: 'EXPERIENCE',
} as const;

export type EventType = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];
